var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 295,
    viewBox: "0 0 324 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281.612,
    cy: 281.122,
    r: 216.878,
    stroke: "#714FFF",
    strokeWidth: 128.376
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBg);
export default __webpack_public_path__ + "static/media/BlueBg.524b9accd85ada9955788d03cccb8511.svg";
export { ForwardRef as ReactComponent };